import { gql } from "@/gql";

export const accountsV2Query = gql(`
  query AccountsV2 {
    accountsV2 {
      id
      cdhId
      isPrimary
      name
    }
  }
`);
